import { apiURL } from 'src/consumer/services'

/**
 * Public receipt link file endpoint (no auth).
 * GET /api/nc/receipt-links/{token}/file
 *
 * @param {string} token - Receipt link token from URL (e.g. /receipt/{token})
 * @returns {Promise<Blob>} PDF blob on 200
 * @throws {Response} Throws the Response on !res.ok so caller can read res.status (410, 409, 404, etc.)
 */
export async function loadReceiptPdf(token) {
  const url = `${apiURL}/api/nc/receipt-links/${encodeURIComponent(token)}/file`
  const res = await fetch(url, { method: 'GET' })
  if (!res.ok) {
    throw res
  }
  return res.blob()
}
